export default "__VITE_ASSET__CcUidVnl__"